import { atom, useRecoilState } from 'recoil';

const activeLetterState = atom<string | null>({
    key: 'activeLetterState',
    default: null,
});

export const useActiveLetterState = () => useRecoilState(activeLetterState);
